var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'השירות הוקפא והתזרים הפסיק להתעדכן.',"text":'כדי שנמשיך לבנות תזרים חודשי ולשלוח עדכונים צריך לעדכן את פרטי התשלום.',"notification-buttons":[
                      {
                        title:'לעדכון פרטי תשלום',
                        variant: 'primary',
                        action: _vm.updatePayment,
                      } ],"icon-type":'danger'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }